import GenericHero from "./GenericHero";

export default GenericHero;
